module.exports = __webpack_public_path__ + "hsbc.jpg?d9be01c949798f3150475360f1473ae9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/hsbc.jpg
// module id = 67
// module chunks = 0